import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import CalendarTodayOutlined from '@material-ui/icons/EventNote';
import { Button } from '@material-ui/core';
import { ButtonMain, DatePicker } from '../../../atoms';
import { RootState } from '../../../redux/root';
import { setBulkActiveTab, setBulkDate, setShowBulkUpdatePopup } from '../../../redux/slices/bulkSlice';
import { DEFAULT_DATE_FORMAT } from '../../../constants';
import { InputDatepickerRange } from '../../../molecules';

const BulkSubTabs = ({ getCount }) => {
  const { bulkActiveTab, bulkDate } = useSelector((s: RootState) => s.bulkSlice);
  const { tableSelectedRows } = useSelector((s: RootState) => s.general);
  const userAuth = useSelector((s: RootState) => s.userAuth);
  const dispatch = useDispatch();
  const bref = useRef<HTMLButtonElement>(null);

  const onClick = who => {
    dispatch(setBulkActiveTab(who));
  };

  const onDateChange = e => {
    console.log(e);
    const _date = format(new Date(e), DEFAULT_DATE_FORMAT);
    dispatch(setBulkDate(_date));
  };

  const onDateClick = e => {
    const elem = e.target.nextSibling;
    e.target.parentNode.nextSibling.firstChild.firstChild.firstChild.click();
  };

    const isButtonDisabled = () => {
      // Only block on the permission when the backend actually reports it.
      // Older / out-of-sync backends (e.g. dev) don't include `canScheduleInspections`
      // in the login payload at all — treating that as "not allowed" left the button
      // permanently dead. Only an explicit `false` disables here.
      if (userAuth?.info?.canScheduleInspections === false) {
        return true;
      }

      if (getCount() > 0) {
        const selectedAny = tableSelectedRows.filter(r => r.selected);
        // setSelectedCount(selectedAny.length);
        return selectedAny.length === 0 || !bulkDate;
      }
      return true;
    };

  return (
    <Wrapper>
      <First>
        <ButtonMain variant={bulkActiveTab === 'I' ? 'contained' : 'outlined'} onClick={e => onClick('I')}>
          inspections
        </ButtonMain>
        <ButtonMain variant={bulkActiveTab === 'R' ? 'contained' : 'outlined'} onClick={e => onClick('R')}>
          Reviews
        </ButtonMain>
        <DateWrapper>
          <Button
            color="primary"
            variant="contained"
            disabled={isButtonDisabled()}
            onClick={() => dispatch(setShowBulkUpdatePopup(true))}
          >
            Bulk Schedule
          </Button>
          <Button ref={bref} variant="outlined" onClick={onDateClick}>
            <CalendarTodayOutlined />
            {bulkDate || 'Select Date'}
          </Button>
          <Picker>
            <DatePicker
              disabled={false}
              onChange={onDateChange}
              dateFormat={DEFAULT_DATE_FORMAT}
              selected={bulkDate ? new Date(bulkDate) : undefined}
              placeholderText=""
              required
            />
          </Picker>
        </DateWrapper>
      </First>
    </Wrapper>
  );
};

export default BulkSubTabs;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 32px;
  gap: 30px;
  padding: 5px;
  margin-top: 19px;
  margin-bottom: 24px;
`;

const Picker = styled.div`
  position: absolute;
  top: 6px;
  input {
    border: none;
    outline: none;
    width: 0;
    margin-left: 5px;
    visibility: hidden;
  }
  .react-datepicker {
    position: relative;
    left: 33px;
    .react-datepicker__triangle {
      left: 148px !important;
    }
  }
`;
const First = styled.div`
  gap: 10px;
  display: flex;
  padding-left: 29px;
  justify-content: space-around;
  width: 100%;
  justify-content: start;
  position: relative;
`;

const DateWrapper = styled.div`
  position: absolute;
  button{
    margin-right: 15px;
  }
  right: 29px;
  svg {
    margin-right: 10px;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

const StyledInputDatepickerRange = styled(InputDatepickerRange)`
  margin-left: 2px;

  .MuiOutlinedInput-root.MuiInputBase-formControl {
    height: 32px;
  }
`;
